import type { ILineItem, OnUpdateLine } from '@features/purchasing/my-basket/types';
import Image from '@store/components/Image';
import React, { useCallback, useState } from 'react';

interface IProps extends ILineItem {
  onUpdate: OnUpdateLine;
}

export default function Line(props: IProps) {
  const [unitCount, setUnitCount] = useState(props.unitCount);

  const onUpdate = useCallback(
    (unitCount: number) => {
      const { productId, optionId, onUpdate } = props;

      onUpdate({ productId, optionId, unitCount });
    },
    [props]
  );

  return (
    <div className="basket-line">
      <div className="column image">
        <a
          href={props.productUrl}
          className="w-24 h-24 flex items-center justify-center shrink-0 overflow-hidden">
          <Image
            src={props.imageUrl}
            alt={props.productName}
            className="max-h-full object-scale-down"
          />
        </a>
      </div>

      <div className="column name">
        <a href={props.productUrl} className="block font-medium leading-normal">
          {props.productName}
        </a>
      </div>

      <div className="column stock text-stock">{props.availability}</div>

      <div className="column code">
        <span className="font-medium">{props.productCode}</span>
      </div>

      <div className="column unit-count">
        <div className="w-full flex justify-end">
          <input
            type="number"
            inputMode="numeric"
            name="unitCount"
            min={1}
            defaultValue={props.unitCount}
            onChange={e => {
              const count = parseInt(e.currentTarget.value);
              setUnitCount(count);
            }}
            onBlur={() => {
              if (isNaN(unitCount) || unitCount === props.unitCount) return;
              onUpdate(unitCount);
            }}
            className="as-text w-full w-16 h-8 px-1 text-center text-xs laptop:text-sm"
          />
        </div>
      </div>

      <div className="column unit-price">
        <span className="w-full text-price font-medium text-right">
          <span>{props.unitPrice.formatted}</span>
          <span className="laptop:hidden"> / {props.measurementUnit}</span>
        </span>
      </div>

      <div className="column total-price">
        <span className="w-full text-price font-medium text-right">
          {props.linePrice.formatted}
        </span>
      </div>

      <div className="column delete">
        <div className="w-full flex justify-end">
          <button
            className="w-6 h-6 inline-flex items-center justify-center bg-gray-200 rounded-full text-gray-600 text-xxs"
            onClick={() => onUpdate(0)}
            type="button">
            <i className="fa-solid fa-times" />
          </button>
        </div>
      </div>
    </div>
  );
}
